import type { Reducer } from "redux";
import { combineReducers } from "redux";
import type { ActionType } from "typesafe-actions";
import { createAction, getType } from "typesafe-actions";
import type { MachineModelHealthStatus } from "~/client/resources";

export const machineActions = {
    machineFetched: createAction("MACHINE_FETCHED", (resolve) => (machine: CurrentMachineState) => resolve(machine)),
    machineSaved: createAction("MACHINE_SAVED", (resolve) => (machine: CurrentMachineState) => resolve(machine)),
    machineCleared: createAction("MACHINE_CLEARED"),
};

type MachineAction = ActionType<typeof machineActions>;

export interface MachinesState {
    current: CurrentMachineState | null;
}

export interface CurrentMachineState {
    id: string;
    name: string;
    machineIconUrl: string;
    machineType: string;
    isDisabled: boolean;
    isStepPackage: boolean;
    healthStatus: MachineModelHealthStatus;
}

const currentMachineReducer: Reducer<CurrentMachineState | null> = (state = null, action: MachineAction) => {
    switch (action.type) {
        case getType(machineActions.machineFetched):
        case getType(machineActions.machineSaved):
            return action.payload;
        case getType(machineActions.machineCleared):
            return null;
        default:
            return state;
    }
};

export default combineReducers<MachinesState>({ current: currentMachineReducer });
